const getChrome = (): boolean => {
    return window.chrome !== undefined
}

export default getChrome;